import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { BsCheckCircle } from "react-icons/bs";
import { BiErrorCircle } from "react-icons/bi";
// import AlertMessage from "../../Component/AlertMessage/AlertMessage";
import apiCall from "../../API/API";
import "./UpdateSlot.css";

const UpdateSlot = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { slot } = location.state || {};

  function delay(delayInms) {
    return new Promise((resolve) => setTimeout(resolve, delayInms));
  }

  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(null);
  const [slotData, setSlotData] = useState({
    _id: "",
    slotId: "",
    // status: "",
    sold_amount: "",
    total_amount: "",
    slot_name: "",
    //  active_status: ""
  });

  useEffect(() => {
    if (slot) {
      setSlotData({
        _id: slot._id || "",
        slotId: slot.slotId || slot.id || "",
        // status: slot.status || "",
        sold_amount: slot.sold_amount !== undefined && slot.sold_amount !== null ? slot.sold_amount : "",
        total_amount: slot.total_amount !== undefined && slot.total_amount !== null ? slot.total_amount : "",
        slot_name: slot.slot_name || "",
        // active_status: slot.active_status || ""
      });
    } else {
      // If no slot data, redirect back to token distribution
      navigate("/dashboard/token_distribution");
    }
  }, [slot, navigate]);

  const handleChange = (event) => {
    setSlotData({
      ...slotData,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    // Prepare the request data
    const requestData = {
      slotId: slotData.slotId,
      //   status: slotData.status,
      sold_amount: slotData.sold_amount !== "" ? parseInt(slotData.sold_amount) : 0,
      total_amount: slotData.total_amount !== "" ? parseInt(slotData.total_amount) : 0,
      slot_name: slotData.slot_name,
      //   active_status: parseInt(slotData.active_status)
    };
    
    // Debug: Log the data being sent
    console.log("Sending update data:", requestData);
    
    // if (validateForm()) {
      const { data, error } = await apiCall(
        "POST",
        "/update_slot",
        requestData,
        true
      );
      
      // Debug: Log the response
      console.log("API Response:", { data, error });
      
      if (data) {
        setSuccess("true");
        setSuccess("null");
        navigate("/dashboard/token_distribution");
      } else {
        setSuccess("false");
        setSuccess("null");
      }
    // }
  };

  const handleCancel = () => {
    navigate("/dashboard/token_distribution");
  };

  return (
    <React.Fragment>
      <Container>
        <section id="editProfile">
          <div
            id="profileImage"
            className="d-flex"
            style={{ justifyContent: "center" }}
          >
            <h1 className="text-center">Update Slot</h1>
          </div>
          <section id="editProfileContent">
            <section>
              <div className="form">
                <Row>
                  <Col lg="12" style={{ margin: "auto" }}>
                    <form onSubmit={handleSubmit} className="registerForm">
                      <div id="changePassword">
                        <Row>
                          <Col lg="6">
                            <div>
                              <label>Slot ID</label>
                              <input
                                type="text"
                                name="slotId"
                                style={{backgroundColor: "lightgray"}}
                                value={slotData.slotId}
                                onChange={handleChange}
                                readOnly
                              />
                              {errors.slotId && (
                                <div className="formError">
                                  {errors.slotId}
                                </div>
                              )}
                            </div>
                          </Col>
                          <Col lg="6">
                            <div>
                              <label>Slot Name</label>
                              <input
                                type="text"
                                name="slot_name"
                                value={slotData.slot_name}
                                onChange={handleChange}
                              />
                              {errors.slot_name && (
                                <div className="formError">
                                  {errors.slot_name}
                                </div>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <div>
                              <label>Sold Amount</label>
                              <input
                                type="number"
                                name="sold_amount"
                                value={slotData.sold_amount}
                                onChange={handleChange}
                                min="0"
                              />
                              {errors.sold_amount && (
                                <div className="formError">
                                  {errors.sold_amount}
                                </div>
                              )}
                            </div>
                          </Col>
                          <Col lg="6">
                            <div>
                              <label>Total Amount</label>
                              <input
                                type="number"
                                name="total_amount"
                                value={slotData.total_amount}
                                onChange={handleChange}
                                min="0"
                              />
                              {errors.total_amount && (
                                <div className="formError">
                                  {errors.total_amount}
                                </div>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <button type="submit" className="save">
                          Update Slot
                        </button>
                        <a onClick={handleCancel} className="cancel">
                          Cancel
                        </a>
                      </div>
                    </form>
                  </Col>
                </Row>
              </div>
            </section>
          </section>
        </section>
        {/* {success === "true" ? (
          <AlertMessage msg="Slot updated successfully" icon={<BsCheckCircle />} />
        ) : success === "false" ? (
          <AlertMessage
            msg="Update failed"
            bgcolor="white"
            color="red"
            hrcolor="red"
            icon={<BiErrorCircle />}
          />
        ) : (
          ""
        )} */}
      </Container>
    </React.Fragment>
  );
};

export default UpdateSlot;
